import { useContext } from "react";
import { Container } from "reactstrap";

//Common
import FormBackGround from "../../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../../common/Forms/FormHeader/FormHeader";
import DisplayData from "../../common/DisplayData/DisplayData";
import ActionBar from "../../common/ActionBar/ActionBar";
import BlockIcon from "../../common/Icons/BlockIcon";
import ActivateIcon from "../../common/Icons/ActivateIcon";
import Button from "../../common/VFX-UI/Button/Button";

//App
import useComponentGeneralStyles from "../../styles";
import { EMPTY_GUID } from "../../../utility/constants/constants";
import { SettingViewProps } from "../../../types/setting";
import { SettingContext } from "./SettingsContainer";

const LookupValueView = (props: SettingViewProps) => {
  const {
    onClose,
    editAction,
    toggleActivateHandler,
    toggleDeactivateHandler,
  } = props;
  const settingContext = useContext(SettingContext);
  const generalStyles = useComponentGeneralStyles();

  const setting = settingContext?.data;

  return (
    <FormBackGround>
      <FormHeader
        title="View Setting"
        chipLabel={setting?.isActive ? "Active" : "Inactive"}
        onClose={onClose}
        editActionHandler={setting?.isActive ? editAction : undefined}
      />
      <Container>
        <DisplayData text="Name" importedData={setting?.name}></DisplayData>
        <DisplayData
          text="Description"
          importedData={setting?.description}
        ></DisplayData>
        <DisplayData text="Code" importedData={setting?.code}></DisplayData>
        <DisplayData
          text="Enum Name"
          importedData={setting?.enumName}
        ></DisplayData>
        <DisplayData
          text="Setting Value"
          importedData={setting?.value}
        ></DisplayData>
        {setting?.id && setting?.id !== EMPTY_GUID && setting?.isActive && (
          <Container>
            <Button
              style={generalStyles.deleteButton}
              onClick={toggleDeactivateHandler}
            >
              <BlockIcon />
            </Button>
          </Container>
        )}
        {setting?.id && setting?.id !== EMPTY_GUID && !setting?.isActive && (
          <Container>
            <Button
              style={generalStyles.activateButton}
              onClick={toggleActivateHandler}
            >
              <ActivateIcon />
            </Button>
          </Container>
        )}
      </Container>
      <Container style={generalStyles.actionBarContainer}>
        <ActionBar cancelHandler={onClose} cancelText="Close"></ActionBar>
      </Container>
    </FormBackGround>
  );
};

export default LookupValueView;
